import { requestApi } from './Api';

export const getPermissions = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/permissions/get',
    params
  });
